import type { RootState, SetState } from '../store';

export type RemindersSliceProps = {
    reminders: {
        remindersByZone: Record<string, boolean>;
        setReminder: (zoneUid: string, isSet: boolean) => void;
    };
};

export const remindersSlice = ({ set }: SetState<RootState>): RemindersSliceProps => ({
    reminders: {
        remindersByZone: {},

        setReminder: (zoneUid: string, isSet: boolean) => {
            set(
                (state) => ({
                    reminders: {
                        ...state.reminders,
                        remindersByZone: {
                            ...state.reminders.remindersByZone,
                            [zoneUid]: isSet
                        }
                    }
                }),
                false,
                'reminders/setReminder'
            );
        }
    }
});
